import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "en", toggle: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("altalib_lang") || "en");

  useEffect(() => {
    localStorage.setItem("altalib_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  return (
    <LanguageContext.Provider
      value={{ lang, toggle: () => setLang((l) => (l === "en" ? "ar" : "en")) }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
